import React, { useState, useRef, useEffect } from 'react';

interface IProps {
    children: React.ReactNode;
    initialHeight?: number;
    minHeight?: number;
    maxHeight?: number;
}

export default function ResizableDiv(props: IProps) {
    const { children, initialHeight, minHeight = 96, maxHeight = 672 } = props;
    const [height, setHeight] = useState(initialHeight || minHeight);
    const startY = useRef(0);
    const startHeight = useRef(0);
    const isResizing = useRef(false);

    useEffect(() => {
        if (initialHeight && initialHeight !== height) {
            setHeight(Math.min(Math.max(initialHeight, minHeight), maxHeight));
        }
    }, [initialHeight]);

    const handleMouseDownResize = (event: React.MouseEvent) => {
        event.preventDefault();
        isResizing.current = true;
        startY.current = event.clientY;
        startHeight.current = height;
        document.addEventListener('mousemove', handleMouseMoveResize);
        document.addEventListener('mouseup', handleMouseUpResize);
    };

    const handleMouseMoveResize = (event: MouseEvent) => {
        if (isResizing.current) {
            const newHeight = startHeight.current + (event.clientY - startY.current);
            setHeight(Math.min(Math.max(newHeight, minHeight), maxHeight));
        }
    };

    const handleMouseUpResize = () => {
        isResizing.current = false;
        document.removeEventListener('mousemove', handleMouseMoveResize);
        document.removeEventListener('mouseup', handleMouseUpResize);
    };

    return (
        <div className='relative w-full' style={{ height: `${height}px` }}>
            {children}
            <div
                className='absolute bottom-0 left-0 w-full h-3 cursor-ns-resize hover:border-b-4 border-cyan-800'
                onMouseDown={handleMouseDownResize}
            />
        </div>
    );
}
